import { useTheme } from 'styled-components';

import ColorPaletteStyled from '../../../components/ColorPalette';

import { type UseCasePaletteId, useCasePalettes } from './chartPalettes';

interface Props {
  palettes: readonly UseCasePaletteId[];
}

// Bare `.palette` blocks, so each UseCaseTab's `.colors > .palette` styles keep applying.
const UseCasePalettes = ({ palettes }: Props) => {
  const theme = useTheme();
  return (
    <>
      {palettes.map((id) => {
        const { title, subtitle, keys } = useCasePalettes[id];
        return (
          <div className="palette" key={id}>
            <h3 className="palette-title">{title}</h3>
            <p>{subtitle}</p>
            <ColorPaletteStyled
              className="color-palette"
              data={keys.map((key, index) => ({ id: index + 1, color: theme[key] }))}
            />
          </div>
        );
      })}
    </>
  );
};

export default UseCasePalettes;
